import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, TAGCarousel, TAGTypography, useMediaQuery } from '../../';
import * as templates from '.';
import Card from './Card';

var Carousel = function Carousel(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      branding = _ref.branding,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      rotationContent = _ref.rotationContent,
      title = _ref.title;
  var mobileWidth = useMediaQuery('(max-width:600px)');
  var theme = useTheme();
  return React.createElement(Grid, {
    container: true,
    sx: fullWidth ? {
      backgroundColor: "backgrounds.".concat(backgroundColor)
    } : {}
  }, React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: 0,
      paddingRight: 0
    })
  }, React.createElement(Grid, {
    item: true,
    sx: {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      padding: '20px 0'
    }
  }, (eyebrow || title || description) && React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    spacing: 2,
    textAlign: "center"
  }, eyebrow && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.secondary',
    variant: mobileWidth ? 'bodySmallBook' : 'bodyMediumBook'
  }, eyebrow)), title && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.primary',
    variant: "h1"
  }, title)), (description === null || description === void 0 ? void 0 : description.description) && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.secondary',
    variant: mobileWidth ? 'bodySmallBook' : 'bodyLargeBook',
    sx: {
      display: 'flex',
      textAlign: 'center'
    }
  }, description.description))), React.createElement(TAGCarousel, {
    arrows: !mobileWidth,
    peeking: mobileWidth
  }, rotationContent.map(function (content, index) {
    var _content$branding, _content$branding2;

    // @ts-ignore
    return content.__typename && content.__typename === 'ContentfulCard' ? React.createElement(Card, {
      branding: (_content$branding = content.branding) !== null && _content$branding !== void 0 ? _content$branding : branding,
      card: content,
      key: "".concat(content.contentful_id, "-rotationContent").concat(index),
      roundedImage: true
    }) : content.__typename && templates[content.__typename.slice(10)] && React.createElement(templates[content.__typename.slice(10)], _objectSpread(_objectSpread({}, content), {}, {
      branding: (_content$branding2 = content.branding) !== null && _content$branding2 !== void 0 ? _content$branding2 : branding,
      centerAlign: false,
      renderAsCards: true,
      key: "".concat(content.contentful_id, "-rotationContent").concat(index)
    }));
  })))));
};

export default Carousel;